import React from "react";
import { createPortal } from "react-dom";
import { STATUS, fmtDate } from "@/lib/constants";
import { useLang } from "@/i18n";

const GAP = 38; // ≈ 10 mm: het venstertje staat altijd 10 mm boven en 10 mm rechts van de muis
const W = 230;

/** Radarvenstertje dat de muis volgt: plaats + status, naam, en tot wanneer bezet. */
export default function PitchRadarTip({ hover }) {
  const { t, lang } = useLang();
  if (!hover) return null;
  const p = hover.pitch;
  const st = STATUS[p.status] || STATUS.vrij;
  const lines = [`${p.label} · ${(st[lang] || st.nl).toUpperCase()}`];
  const busy = p.status === "bezet" || p.status === "gereserveerd";
  if (busy && p.guest_name) lines.push(p.guest_name);
  if (p.status === "buiten_dienst") {
    if (p.note) lines.push(p.note);
    lines.push(p.oos_until ? `${t("oos_until")} ${fmtDate(p.oos_until)}` : t("oos_permanent"));
  } else if (busy && p.stay_departure) {
    lines.push(`${t("until")} ${fmtDate(p.stay_departure)}`);
  }

  // Portal naar <body>: binnen de gezoomde (CSS-transform) kaart zou position:fixed t.o.v. de kaart rekenen
  return createPortal(
    <div data-testid="pitch-radar-tip"
      style={{
        position: "fixed",
        left: hover.x + GAP + W > window.innerWidth ? hover.x - GAP - W : hover.x + GAP,
        ...(hover.y - GAP > 90 ? { bottom: window.innerHeight - hover.y + GAP } : { top: hover.y + GAP }),
        zIndex: 60, pointerEvents: "none", minWidth: 150, maxWidth: W,
        padding: "8px 11px", borderRadius: 10,
        background: "radial-gradient(120% 120% at 20% 0%, rgba(6,32,18,.97), rgba(2,14,8,.97))",
        border: "1px solid rgba(34,197,94,.55)",
        boxShadow: "0 0 0 1px rgba(34,197,94,.12), 0 10px 26px -10px rgba(16,185,129,.65), inset 0 0 22px rgba(34,197,94,.14)",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
        fontSize: 12, lineHeight: 1.5, letterSpacing: ".04em",
        color: "#4ade80", textShadow: "0 0 7px rgba(74,222,128,.75)",
      }}>
      {lines.map((l, i) => (
        <div key={i} style={{ fontWeight: i === 0 ? 700 : 500, opacity: i === 0 ? 1 : 0.92, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {i === 0 ? "" : "› "}{l}
        </div>
      ))}
    </div>,
    document.body,
  );
}
